import script from "./ATR.vue?vue&type=script&lang=js"
export * from "./ATR.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__